import { render, staticRenderFns } from "./NodeOnboardingPaletteButtons.vue?vue&type=template&id=92237d06&"
import script from "./NodeOnboardingPaletteButtons.vue?vue&type=script&lang=ts&"
export * from "./NodeOnboardingPaletteButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports